module.exports = __webpack_public_path__ + "img/icon_id_card_verify.6866ccb5.png";